module.exports = __webpack_public_path__ + "img/sumdes_600.4a8296f2.png";